import ActionTypes from "./action-types.js";
import { createAction } from "redux-actions";
import { LocalStorage } from "../site/localStorage";

const ANALYTICS_PREVIOUS_LOCATION_CONTEXT_STORE_KEY = "analytics_previous_location_context";
const PREVIOUS_LOCATION_SOURCE_KEY = "previous_location";

const actions = {
  setPreviousLocationContext: createAction(ActionTypes.ANALYTICS_PREVIOUS_LOCATION_CONTEXT_SET),

  // NW [EXPLANATION] 4/23/19: Data Science wants to know which carousel or grid the user came from, after they land on the PDP and start hearting/adding to bag.
  // To perist this context to the PDP, we store it in localStorage. When the PDP mounts, we will save it in Redux and clear it from localStorage, so subsequent navigation is unaffected.
  savePreviousLocationContextToStorage: previousLocationContext => {
    const localStorageClient = new LocalStorage(ANALYTICS_PREVIOUS_LOCATION_CONTEXT_STORE_KEY);
    localStorageClient.set(PREVIOUS_LOCATION_SOURCE_KEY, previousLocationContext);
  },

  readPreviousLocationContextFromStorage: () => {
    const localStorageClient = new LocalStorage(ANALYTICS_PREVIOUS_LOCATION_CONTEXT_STORE_KEY);
    return localStorageClient.get(PREVIOUS_LOCATION_SOURCE_KEY);
  },

  clearPreviousLocationContextFromStorage: () => {
    const localStorageClient = new LocalStorage(ANALYTICS_PREVIOUS_LOCATION_CONTEXT_STORE_KEY);
    localStorageClient.remove(PREVIOUS_LOCATION_SOURCE_KEY);
  },
};

export default actions;

export const {
  setPreviousLocationContext,
  savePreviousLocationContextToStorage,
  readPreviousLocationContextFromStorage,
  clearPreviousLocationContextFromStorage,
} = actions;
